<section id="faq" class="faq-section">
  <div class="faq-bg">
    <div class="faq-grid-pattern"></div>
    <div class="faq-orb faq-orb-1"></div>
    <div class="faq-orb faq-orb-2"></div>
  </div>

  <div class="faq-wrap reusable-container">
    <!-- LEFT: sticky header + help card -->
    <aside class="faq-aside">
      <div class="faq-eyebrow">
        <span class="dot"></span>
        Frequently asked
      </div>
      <h2 class="faq-title">
        Everything you<br />
        need to <span class="accent">know.</span>
      </h2>
      <p class="faq-sub">
        Clear answers to the questions institutions ask us most.
        Can't find yours? Our team responds within one business day.
      </p>

      <!-- Support CTA card -->
      <div class="faq-help">
        <div class="faq-help-avatars">
          <span class="faq-avatar faq-avatar-1">
            <mat-icon>support_agent</mat-icon>
          </span>
          <span class="faq-avatar faq-avatar-2">
            <mat-icon>headset_mic</mat-icon>
          </span>
          <span class="faq-avatar faq-avatar-3">
            <mat-icon>contact_support</mat-icon>
          </span>
        </div>
        <div class="faq-help-text">
          <strong>Still have questions?</strong>
          <span>Our humans reply within a day.</span>
        </div>
        <button class="faq-help-btn">
          Contact support
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </aside>

    <!-- RIGHT: category chips + accordion -->
    <div class="faq-main">
      <!-- Category chip rail -->
      <div class="faq-chips">
        <button
          *ngFor="let category of faqCategories"
          type="button"
          class="faq-chip"
          [class.active]="selectedCategory === category"
          (click)="selectCategory(category)">
          <span>{{ category.toLowerCase() | titlecase }}</span>
          <mat-icon class="faq-chip-check">check</mat-icon>
        </button>
      </div>

      <!-- Accordion -->
      <div class="faq-list">
        <ng-container *ngIf="filteredFaqs?.length; else noFaqs">
          <article
            *ngFor="let faq of filteredFaqs; let i = index"
            class="faq-item"
            [class.open]="activeIndex === i">
            <button
              type="button"
              class="faq-q"
              (click)="toggle(i)"
              [attr.aria-expanded]="activeIndex === i">
              <span class="faq-num">{{ (i + 1).toString().padStart(2, '0') }}</span>
              <span class="faq-question">{{ faq.question }}</span>
              <span class="faq-toggle">
                <span class="bar bar-h"></span>
                <span class="bar bar-v"></span>
              </span>
            </button>

            <div class="faq-a-wrap" [style.max-height]="activeIndex === i ? '600px' : '0px'">
              <div class="faq-a">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </article>
        </ng-container>

        <ng-template #noFaqs>
          <div class="faq-empty">
            <mat-icon>help_outline</mat-icon>
            <p>No FAQs available yet.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</section>
